<template>
  <div class="sidebar">
    <div class="home">
      <div class="icon">
        <img
          :class="{
            animate: animateHomeIcon,
            advocate: side == `advocate`,
            adversary: side == `adversary`,
          }"
          src="~@/assets/images/icon-logo.png"
          alt="THE_ADV"
        />
      </div>
    </div>
    <div class="main">
      <div class="row nav">
        <div
          class="icon"
          :class="{ active: pageName == 'timer', inactive: pageIndex > 1 }"
          @mouseover="rolloverText1 = 'countdown'"
          @mouseout="rolloverText1 = ''"
          @click="navClick('timer', $event)"
        >
          <img src="~@/assets/images/icon-timer.png" />
        </div>

        <div
          class="icon"
          :class="{ active: pageName == 'welcome', inactive: pageIndex > 2 }"
          @mouseover="rolloverText1 = 'welcome'"
          @mouseout="rolloverText1 = ''"
          @click="navClick('welcome', $event)"
        >
          <img src="~@/assets/images/icon-welcome.png" />
        </div>

        <div
          class="icon"
          :class="{ active: pageName == 'scenario', inactive: pageIndex > 3 }"
          @mouseover="rolloverText1 = 'scenario'"
          @mouseout="rolloverText1 = ''"
          @click="navClick('scenario', $event)"
        >
          <img src="~@/assets/images/icon-scenario.png" />
        </div>
      </div>
      <div class="row rollover">
        <span v-show="rolloverText1">
          [
          <i>{{ rolloverText1 }}</i> ]
        </span>
      </div>
      <div class="row nav">
        <div
          class="icon"
          :class="{ active: pageName == 'sides', inactive: pageIndex > 4 }"
          @mouseover="rolloverText2 = 'approach'"
          @mouseout="rolloverText2 = ''"
          @click="navClick('sides', $event)"
        >
          <img src="~@/assets/images/icon-side.png" />
        </div>

        <div
          class="icon"
          :class="{ active: pageName == 'names', inactive: pageIndex > 5 }"
          @mouseover="rolloverText2 = 'register'"
          @mouseout="rolloverText2 = ''"
          @click="navClick('names', $event)"
        >
          <img src="~@/assets/images/icon-names.png" />
        </div>

        <div
          class="icon"
          :class="{ active: pageName == 'pledge', inactive: pageIndex > 6 }"
          @mouseover="rolloverText2 = 'oath'"
          @mouseout="rolloverText2 = ''"
          @click="navClick('pledge', $event)"
        >
          <img src="~@/assets/images/icon-pledge.png" />
        </div>
      </div>
      <div class="row rollover">
        <span v-show="rolloverText2">
          [
          <i>{{ rolloverText2 }}</i> ]
        </span>
      </div>
      <div class="row nav">
        <div
          class="icon"
          :class="{ active: pageName == 'task', inactive: pageIndex > 7 }"
          @mouseover="rolloverText3 = 'task'"
          @mouseout="rolloverText3 = ''"
          @click="navClick('task', $event)"
        >
          <img src="~@/assets/images/icon-task.png" />
        </div>

        <div
          class="icon"
          :class="{ active: pageName == 'difficulty', inactive: pageIndex > 8 }"
          @mouseover="rolloverText3 = 'difficulty'"
          @mouseout="rolloverText3 = ''"
          @click="navClick('difficulty', $event)"
        >
          <img src="~@/assets/images/icon-difficulty.png" />
        </div>

        <div
          class="icon"
          :class="{ active: pageName == 'roles', inactive: pageIndex > 9 }"
          @mouseover="rolloverText3 = 'identity'"
          @mouseout="rolloverText3 = ''"
          @click="navClick('roles', $event)"
        >
          <img src="~@/assets/images/icon-identity.png" />
        </div>
      </div>
      <div class="row rollover">
        <span v-show="rolloverText3">
          [
          <i>{{ rolloverText3 }}</i> ]
        </span>
      </div>
      <div class="row nav">
        <div
          class="icon"
          :class="{ active: pageName == 'strategy', inactive: pageIndex > 10 }"
          @mouseover="rolloverText4 = 'strategy'"
          @mouseout="rolloverText4 = ''"
          @click="navClick('strategy', $event)"
        >
          <img src="~@/assets/images/icon-strategy.png" />
        </div>

        <div
          class="icon"
          :class="{ inactive: pageIndex > 10 }"
          @mouseover="rolloverText4 = 'clue 01'"
          @mouseout="rolloverText4 = ''"
          @click="hint(0, $event)"
        >
          <img
            src="~@/assets/images/icon-hint.png"
            :class="{ animate: pageName == 'roles' || pageName == 'strategy' }"
          />
        </div>

        <div
          class="icon"
          :class="{ inactive: pageIndex > 10 }"
          @mouseover="rolloverText4 = 'clue 02'"
          @mouseout="rolloverText4 = ''"
          @click="hint(1, $event)"
        >
          <img
            src="~@/assets/images/icon-hint.png"
            :class="{ animate: pageName == 'roles' || pageName == 'strategy' }"
          />
        </div>
      </div>
      <div class="row rollover">
        <span v-show="rolloverText4">
          [
          <i>{{ rolloverText4 }}</i> ]
        </span>
      </div>

      <template
        v-if="
          difficulty === '' || difficulty === 'easy' || difficulty === 'medium'
        "
      >
        <div class="row nav">
          <div
            class="icon"
            :class="{ inactive: pageIndex > 10 }"
            @mouseover="rolloverText5 = 'clue 03'"
            @mouseout="rolloverText5 = ''"
            @click="hint(2, $event)"
          >
            <img
              src="~@/assets/images/icon-hint.png"
              :class="{
                animate: pageName == 'roles' || pageName == 'strategy',
              }"
            />
          </div>

          <div
            class="icon"
            :class="{ inactive: pageIndex > 10 }"
            @mouseover="rolloverText5 = 'clue 04'"
            @mouseout="rolloverText5 = ''"
            @click="hint(3, $event)"
          >
            <img
              src="~@/assets/images/icon-hint.png"
              :class="{
                animate: pageName == 'roles' || pageName == 'strategy',
              }"
            />
          </div>

          <div
            class="icon"
            :class="{ inactive: pageIndex > 10 }"
            @mouseover="rolloverText5 = 'clue 05'"
            @mouseout="rolloverText5 = ''"
            @click="hint(4, $event)"
          >
            <img
              src="~@/assets/images/icon-hint.png"
              :class="{
                animate: pageName == 'roles' || pageName == 'strategy',
              }"
            />
          </div>
        </div>
        <div class="row rollover">
          <span v-show="rolloverText5">
            [
            <i>{{ rolloverText5 }}</i> ]
          </span>
        </div>
      </template>

      <template v-if="difficulty === '' || difficulty === 'easy'">
        <div class="row nav">
          <div
            class="icon"
            :class="{ inactive: pageIndex > 10 }"
            @mouseover="rolloverText6 = 'clue 06'"
            @mouseout="rolloverText6 = ''"
            @click="hint(5, $event)"
          >
            <img
              src="~@/assets/images/icon-hint.png"
              :class="{
                animate: pageName == 'roles' || pageName == 'strategy',
              }"
            />
          </div>

          <div
            class="icon"
            :class="{ inactive: pageIndex > 10 }"
            @mouseover="rolloverText6 = 'clue 07'"
            @mouseout="rolloverText6 = ''"
            @click="hint(6, $event)"
          >
            <img
              src="~@/assets/images/icon-hint.png"
              :class="{
                animate: pageName == 'roles' || pageName == 'strategy',
              }"
            />
          </div>

          <div
            class="icon"
            :class="{ inactive: pageIndex > 10 }"
            @mouseover="rolloverText6 = 'clue 08'"
            @mouseout="rolloverText6 = ''"
            @click="hint(7, $event)"
          >
            <img
              src="~@/assets/images/icon-hint.png"
              :class="{
                animate: pageName == 'roles' || pageName == 'strategy',
              }"
            />
          </div>
        </div>
        <div class="row rollover">
          <span v-show="rolloverText6">
            [
            <i>{{ rolloverText6 }}</i> ]
          </span>
        </div>
      </template>

      <div class="row nav" v-if="tactics">
        <div
          v-for="(tactic, index) in tactics"
          :key="index"
          class="icon"
          :class="{ active: tactic.active, inactive: pageIndex > 10 }"
          @mouseover="rolloverText9 = 'tactic 0' + (index + 1)"
          @mouseout="rolloverText9 = ''"
          @click="showTactic(tactic)"
        >
          <img
            src="~@/assets/images/icon-tactic.png"
            :class="{
              animate_inverted: pageIndex == 10,
            }"
          />
        </div>
      </div>

      <div class="row nav" v-else>
        <div
          v-for="n in 3"
          :key="n"
          class="icon"
          :class="{ inactive: pageIndex > 10 }"
          @mouseover="rolloverText9 = 'tactic 0' + n"
          @mouseout="rolloverText9 = ''"
          @click="$store.dispatch('playHowler', 'denied')"
        >
          <img src="~@/assets/images/icon-tactic.png" />
        </div>
      </div>

      <div class="row rollover">
        <span v-show="rolloverText9">
          [
          <i>{{ rolloverText9 }}</i> ]
        </span>
      </div>

      <div class="row nav">
        <div
          class="icon"
          :class="{ active: pageName == 'confirm', inactive: pageIndex > 11 }"
          @mouseover="rolloverText7 = 'adjustments'"
          @mouseout="rolloverText7 = ''"
          @click="navClick('confirm', $event)"
        >
          <img src="~@/assets/images/icon-adjustments.png" />
        </div>

        <div
          class="icon"
          :class="{ active: pageName == 'aftermath', inactive: pageIndex > 12 }"
          @mouseover="rolloverText7 = 'discuss'"
          @mouseout="rolloverText7 = ''"
          @click="navClick('aftermath', $event)"
        >
          <img src="~@/assets/images/icon-discuss.png" />
        </div>

        <div
          class="icon"
          :class="{
            active: pageName == 'questionnaire',
            inactive: pageIndex > 13,
          }"
          @mouseover="rolloverText7 = 'questionnaire'"
          @mouseout="rolloverText7 = ''"
          @click="navClick('questionnaire', $event)"
        >
          <img src="~@/assets/images/icon-questionnaire.png" />
        </div>
      </div>
      <div class="row rollover">
        <span v-show="rolloverText7">
          [
          <i>{{ rolloverText7 }}</i> ]
        </span>
      </div>

      <div class="row nav">
        <div
          class="icon"
          @mouseover="rolloverText8 = 'volume'"
          @mouseout="rolloverText8 = ''"
          @click="$store.dispatch('showVolumeControls')"
        >
          <img src="~@/assets/images/icon-volume.png" />
        </div>

        <div
          class="icon"
          :class="{ active: showControllerPage }"
          @mouseover="rolloverText8 = 'controller'"
          @mouseout="rolloverText8 = ''"
          @click="$store.dispatch('toggleControllerPage')"
        >
          <img src="~@/assets/images/icon-participant.png" />
          <span class="participant-number">{{ usersList.length }}</span>
        </div>

        <div
          class="icon"
          :class="{ active: requestingHelp }"
          @mouseover="rolloverText8 = 'help'"
          @mouseout="rolloverText8 = ''"
          @click="requestHelp()"
        >
          <img
            src="~@/assets/images/icon-help.png"
            :class="{ animate: requestingHelp }"
          />
        </div>
      </div>

      <div class="row rollover">
        <span v-show="rolloverText8">
          [
          <i>{{ rolloverText8 }}</i> ]
        </span>
      </div>
    </div>

    <clock class="small"></clock>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Clock from "@/components/Clock.vue";
import Icon from "@/components/Icon.vue";

export default {
  name: "sidebar",
  components: {
    Clock,
    // Icon
  },

  data() {
    return {
      rolloverText1: "",
      rolloverText2: "",
      rolloverText3: "",
      rolloverText4: "",
      rolloverText5: "",
      rolloverText6: "",
      rolloverText7: "",
      rolloverText8: "",
      rolloverText9: "",
    };
  },

  computed: {
    pageIndex() {
      if (this.currentPage) {
        return this.currentPage.index;
      }
      return -1;
    },
    pageName() {
      if (this.currentPage) {
        return this.currentPage.name;
      }
      return "";
    },
    animateHomeIcon() {
      return this.pageName == "sides";
    },
    ...mapGetters(["currentPage", "usersList", "tactics"]),
    ...mapState([
      "difficulty",
      "session",
      "requestingHelp",
      "user",
      "scenario",
      "side",
      "showControllerPage"
    ]),
  },

  methods: {
    navClick(newPage, event) {
      if (event.shiftKey == true && this.user.isAdmin) {
        this.$store.dispatch("goto", newPage);
      } else {
        this.$store.dispatch("playHowler", "denied");
      }
    },

    requestHelp() {
      let help = confirm("Ask the operator for help?");
      if (help) {
        this.$store.dispatch("requestHelp");
      }
    },

    hint(hintIndex, event) {
      if (
        event.shiftKey == true ||
        this.pageName === "roles" ||
        this.pageName === "strategy"
      ) {
        // commit directly and bypass setter, so that even admins can view hints if they want
        if (this.$store.state.side === "advocate") {
          this.$store.dispatch(
            "showHint",
            "<b>[</b> <i>Clue 0" +
              (hintIndex + 1) +
              "</i><b> ]</b> <i><br><br>" +
              this.$store.state.scenario.advocateHints[hintIndex] +
              "</i>"
          );
        } else if (this.$store.state.side === "adversary") {
          this.$store.dispatch(
            "showHint",
            "<b>[</b> <i>Clue 0" +
              (hintIndex + 1) +
              "</i><b> ]</b> <i><br><br>" +
              this.$store.state.scenario.adversaryHints[hintIndex] +
              "</i>"
          );
        } else {
          console.error("no side set yet");
        }

        // this.$store.dispatch("showHint", hint);
      } else {
        this.$store.dispatch("playHowler", "denied");
      }
    },

    showTactic(tactic) {
      // only allow when inside strategy page
      if (this.pageIndex == 10) {
        this.$store.dispatch("showTactic", tactic);
      } else {
        this.$store.dispatch("playHowler", "denied");
      }
    },
  },
};
</script>

<style lang="less">
@keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.25;
  }
  100% {
    opacity: 1;
  }
}

@keyframes flickerAnimation_inverted {
  0% {
    opacity: 0.25;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.25;
  }
}

.animate {
  animation: flickerAnimation 3s infinite;
}

.animate_inverted {
  animation: flickerAnimation_inverted 3s infinite;
}

.sidebar {
  width: 256px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .home {
    padding: 0px 40px 0 40px;
    text-align: center;

    .icon {
      background-color: #f1ece6;
    }

    img {
      width: 30px;
      height: 30px;
      object-fit: cover;
      object-position: 0 0;

      &.advocate {
        object-position: 50% 0;
        animation: flickerAnimation 3s infinite;
      }

      &.adversary {
        object-position: 100% 0;
        animation: flickerAnimation 3s infinite;
      }
    }
  }

  .main {
    padding: 40px;

    .row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 0 10px;

      &.nav {
        background-image: url("~@/assets/images/Sidebar-dot-bg.png");

        .icon {
          background-color: #f1ece6;
          position: relative;

          img {
            width: 40px;
            height: 40px;
            object-fit: cover;
            object-position: 0 0;

            &:hover {
              // opacity: 0.25;
            }
          }

          &.active {
            color: #f1ece6;
          }

          &.active img {
            object-position: 100% 0;
          }

          &.inactive img {
            opacity: 0.25;
          }

          .participant-number {
            display: block;
            position: absolute;
            text-align: center;
            font-size: 10pt;
            top: 24px;
            left: 0;
            width: 40px;
          }
        }
      }

      &.rollover {
        font-size: 13px;
        padding: 4px;
        height: 20px;
        text-align: center;
        display: block;
      }
    }
  }

  &.disabled .main img {
    cursor: not-allowed;
  }
}
</style>
